export const module = {
  info: {
    name: 'subscription-features-package',
    caption: 'subscription features package',
    viewGroup: 'mrt-modules'
  },
  vuexModules: ['api', 'state'],
  mainRoute: '/cpanel',
  // noRoutes: true,
  sideMenu: {
    topSeparator: false,
    caption: 'Features Packages',
    icon: 'el-icon-folder',
    routeName: 'module->subscription-features-package->list->page',
    routeParams: { listPage: 1}
    /*children: [
      {
        caption: 'Create Entity',
        icon: 'el-icon-plus',
        routeName: 'module->subscription-features-package->create'
      },
      {
        caption: 'List Entities',
        icon: 'el-icon-more-outline',
        routeName: 'module->subscription-features-package->list->page',
        routeParams: { listPage: 1}
      }
    ]*/
  }
}

export default module
